module.exports = __webpack_public_path__ + "media/components/assets/vent_01-d6c1259750df22886b1ccec865dd0c51.jpg";